import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

const subscriptionService = {
  async userList({ page = 0, limit = 10, search = null, user_uuid = null } = {}) {
    try {
      const params = { page, limit, search };
      if (user_uuid) {
        params.user_uuid = user_uuid;
      }
      const response = await axiosInstance.get(ENDPOINTS.SUBSCRIPTIONS.USER_LIST, {
        params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default subscriptionService;

